import React, { useEffect, useRef, memo } from 'react';

function TradingViewSymbolProfileWidget({ ticker }) {
  const container = useRef();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-profile.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      {
        "width": "100%",
        "height": "100%",
        "isTransparent": false,
        "colorTheme": "dark",
        "symbol": "${ticker}",
        "locale": "en"
      }`;
    
    const currentContainer = container.current;
    currentContainer.appendChild(script);

    return () => {
      // Cleanup
      if (currentContainer && script.parentNode === currentContainer) {
        currentContainer.removeChild(script);
      }
      // Clear the container content to remove any remaining widget elements
      if (currentContainer) {
        currentContainer.innerHTML = '';
      }
    };
  }, [ticker]);

  return (
    <div className="tradingview-widget-container" ref={container}>
      <div className="tradingview-widget-container__widget"></div>
      <div className="tradingview-widget-copyright">
        
      </div>
    </div>
  );
}

export default memo(TradingViewSymbolProfileWidget); 